export default __webpack_public_path__ + "static/media/discovery_Bg_small.4471238b.jpg";